import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB2D92d4Nyx4FvCiKvyhJC0pZQMeFnfO-Y",
  authDomain: "diffsona-9ec67.firebaseapp.com",
  projectId: "diffsona-9ec67",
  storageBucket: "diffsona-9ec67.firebasestorage.app",
  messagingSenderId: "784483608563",
  appId: "1:784483608563:web:fd4b6e654b7115442e5486"
};

// Initialize Firebase app only once
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Export the singleton auth instance
export const auth = getAuth(app);

// Helper function to sign in anonymously
export const signInAnonymouslyIfNeeded = async (): Promise<string> => {
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken();
  }

  const result = await signInAnonymously(auth);
  return await result.user.getIdToken();
};
